import { Button, styled } from '@mui/material';

export const StyledNormalButton = styled(Button)(({ theme }) => ({
    alignItems: 'center',
    borderWidth: '3px',
    display: 'flex',
    justifyContent: 'center',
    minWidth: 0,
    [theme.breakpoints.up('xs')]: {
        height: '2.5rem',
        padding: '0.5rem 1rem',
    },
    [theme.breakpoints.up('sm')]: {
        height: '3rem',
        padding: '0.6rem 1.2rem',
    },
    [theme.breakpoints.up('md')]: {
        height: '3.5rem',
        padding: '0.8rem 1.5rem',
    },
    [theme.breakpoints.up('lg')]: {
        height: '4rem',
        padding: '1rem 2rem',
    },
    [theme.breakpoints.up('xl')]: {
        height: '4.5rem',
        padding: '1.2rem 2.5rem',
    },
    [theme.breakpoints.up('xxl')]: {
        padding: '3rem 3rem',
    },
}));
